$(document).ready(function(){
  //featured collection section slider 
    var swiper = new Swiper(".swiper-container", {
      slidesPerView: 1,
//         loop: true,
//        centeredSlides: true,
     grabCursor: true,
      draggable: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
         breakpoints: {
            0: {
              slidesPerView: 1,
            },
            480: {
              slidesPerView: 2,
            },
            768: {
              slidesPerView: 3,
            },
            1024: {
              slidesPerView: 4,
            },
          },
    });

  //team section slider 

   var swiper = new Swiper(".itg_team", {
         slidesPerView: 5,
         spaceBetween: 0,
          loop: true,
        navigation: {
          nextEl: ".swiper-but-next",
          prevEl: ".swiper-but-prev",
        },
          breakpoints: {
            0: {
          slidesPerView: 1,
        },
         320: {
          slidesPerView: 2,
        },    
        480: {
          slidesPerView: 3,
          spaceBetween: 5,
        },
        767: {
          slidesPerView: 4,
        },
        1024: {
          slidesPerView: 5,
        },
      }
      });


  //testimonial section slider
  var swiper = new Swiper(".itg_testimonial_slider", {   
    slidesPerView: 3,  
     spaceBetween: 10,
     centeredSlides: true,
      loop: true,
         navigation: {
           nextEl: ".swiper-btn-next",
           prevEl: ".swiper-btn-prev",
         },
          breakpoints: {
            0: {
          slidesPerView: 1,
          centeredSlides: false,
        },
        320: {
          slidesPerView: 1,
          centeredSlides: false,
        },
        767: {
          slidesPerView: 2,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: 3,
        },
      }
        
  });

  //subcollection slider
   // var swiper = new Swiper(".itg_subcollection_slider", {   
   //  slidesPerView: 5,
   //    loop: true,
   //       autoplay: {
   //        delay: 2500,
   //        disableOnInteraction: false,
   //      }
        
   //    });
  
  //mega menu 
  $('ul.list-menu.list-menu--inline li.itg_sidebar_style_menu .mega-menu__content ul.mega-menu__list li:first-child').addClass('active');
  $('ul.list-menu.list-menu--inline li.itg_sidebar_style_menu .mega-menu__content ul.mega-menu__list li').mouseover(function(){
      $(this).parents('ul.mega-menu__list').find('li.active').removeClass('active');
      $(this).addClass('active');
  
  });

  //videoplay btn
  $('.itg_playbtn').click(function(){
    $('.itg_video_main_div .deferred-media__poster').hide();
    $('#video').get(0).play();
  });

  //product color slider 
   var swiper = new Swiper(".slider_color", {
         slidesPerView: 4,
         spaceBetween: 10,
          loop: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });

    //product page
    var qty_val = $( "#qty_option option:selected" ).val();
    $('#quantity_box').val(qty_val);
    $(document).on('change','#qty_option', function() {
      var valdata = $(this).val();
      $('#quantity_box').val(valdata);
    });

   $(".order_sample").click(function(e) {
      var variant_id = $(this).attr('data-variantid');
       if(variant_id != ''){
      var old_variant_id = $('.itg_option').val();
      $('.itg_option').val(variant_id);
      $('.product-form__submit').click();
      $('.itg_option').val(old_variant_id); 
      }
    });



  $(".request_price").click(function(e) {
    $('.request_form').show();
    });
    $(".close_icon").click(function(e) {
    $('.request_form').hide();
    });

    $(".tab_list span").click(function(e) {
        var tabName = $(this).attr('data-name');
        $(this).addClass('active_tabs').siblings().removeClass('active_tabs');
        $('.tab_details .tab_content').each(function() {
          var tabName_box = $(this).attr('data-name');
          if (tabName_box == tabName) {
            $(this).addClass('active_content');
          }else{
            $(this).removeClass('active_content');
          }
        })
    });
  //collection page list view and grid view js

  $('.square-btn').on('click', function(e) {
    $('ul#product-grid').removeClass('itg_grid');
    $('ul#product-grid').removeClass('itg_list');
   // $('ul#product-grid').removeClass('itg_small_list');
  if ($(this).hasClass('itg_list')) {
    $('ul#product-grid').addClass('itg_list');
    var coll_view_click = $(this).closest('li').attr('data-list');
    localStorage.setItem('collection_view', coll_view_click);
    //localStorage.setItem('collection_view', $('.collection').html());
  } else if ($(this).hasClass('itg_grid')) {
    $('ul#product-grid').addClass('itg_grid');
    var coll_view_click = $(this).closest('li').attr('data-list');
    localStorage.setItem('collection_view', coll_view_click);
    //localStorage.setItem('collection_view', $('.collection').html());
  }
  //else if ($(this).hasClass('itg_small_list')) {
  //  $('ul#product-grid').addClass('itg_small_list');
  //}
});
  if (window.localStorage.getItem('collection_view') != null) {
    
      if(localStorage.getItem('collection_view') == 'list_view'){
        $('.itg_list_grid_view .itg_list').trigger('click');
      }
      else if(localStorage.getItem('collection_view') == 'grid_view'){
        $('.itg_list_grid_view .itg_grid').trigger('click');
      }
   // alert(col_len);
  //$('.product-grid-container .collection').html(window.localStorage.getItem('collection_view'));
  }
  //collection page wishlist toggel
  $('.AddToWishDropArrow').click(function(){
    $(this).closest('.itg_btn_group').siblings('.itg_group_data').slideToggle();
  });


//collection ajax custom filter 
  function itgFilter(){
    	var collection_url = $(document).find('.itg_filter_maindiv').attr('data-url');
      	var tag_list = '/';
        $(document).find('.main-filter.active_box').find('input').each(function(index){
          if( index == 0 ){
            tag_list += $(this).val();         	
          }else{
            tag_list += '+'+$(this).val(); 
          }
        });
      	collection_url +=tag_list;
        $.ajax({
          type: 'GET',
          url: collection_url,
          beforeSend: function() {
          },
          success: function(data) {
            var itg_product_count = $(data).find(".itg_product_count").html();
            var collectionGrid = $(data).find(".itg_filter_maindiv").html();
            $(document).find('.itg_product_count').html(itg_product_count);
            $(document).find('.itg_filter_maindiv').html(collectionGrid);
            var obj = { Title: 'ChangeUrl', Url: collection_url };  
    		history.pushState(obj, obj.Title, obj.Url);
            // the grid was replaced: give the fresh cards their slider + images
            if (typeof window.itgInitCardSliders === 'function') {
              window.itgInitCardSliders(document);
            }
            if (typeof window.itgWatchLazyImages === 'function') {
              window.itgWatchLazyImages(document);
            }
          },
          dataType: "html"
        }); 

  }
  /*
  $(document).on('click','.itg_filter ul.nav li label',function(e){
    e.preventDefault();
    if( $(this).closest('.main-filter').hasClass('active_box') ){
    	$(this).closest('.main-filter').removeClass('active_box');
        $(this).find('.itg_checkbox').removeClass('itg_check');
    }else{    	
    	$(this).closest('.main-filter').addClass('active_box');
        $(this).find('.itg_checkbox').addClass('itg_check');
    }
    itgFilter();
  });
*/


  //local storage 
//Collection page 
  // $('.itg_show_filter').on("click", function(){
  //  $(this).parents('.itg_filter_maindiv').toggleClass('itg_nofilter_apply');
  // });

  //product image
  $('.product__media-item').each(function(){
    
  var img_alt = $(this).find('.product__media img').attr('alt');
  //alert(img_alt);
    if(img_alt == 'hide'){
      $(this).css("display", "none");
    }
  });
  $('.thumbnail-list__item').each(function(){
    
  var thumbimg_alt = $(this).find('.thumbnail img').attr('alt');
 if(thumbimg_alt == 'hide'){
      $(this).css("display", "none");
    }
  });
  $('.product-media-modal__dialog .product-media-modal__content img').each(function(){
        if(($(this).attr('alt')) == 'hide' ){
          $(this).css("display", "none");
        } 
  });


  ////product sku get 
  var product_url = $('.list_sku').attr('data-url');
  if(product_url != ''){
    
  $('.list_sku li').each(function() {
    var skuItem = $(this).attr('data-value');
    var url = product_url+'/search?q="'+skuItem+'"&view=search_sku';
    count = 1;
    $.ajax({
           type: 'GET',
           url: url,
           dataType: 'HTML',
           success: function(data) { 
           var sku_data = $(data).find('.itg_sku_item').html();
           $('.hide_sku_get').append(sku_data);   
           $('.hide_sku_get .item_name').each(function name(params) {
             var sku = $(this).attr('data-sku');
             if(sku == skuItem){
                $('.slider_color .swiper-wrapper').append($(this).html()); 
             }
           })
            // $('.slider_color .swiper-wrapper').append(HTMLDIV);
           }
       }); 
  });   
  }

//calculator page 
   $('#itg_calculator_form').on('submit', function (e) {
      e.preventDefault();  
    var first_wall = 1;
    var second_wall = 1;
    var third_wall = 1;
    var four_wall = 1;
    $('.itg_cal_for_group .itg_calculate_field').each(function(){
      if($(this).hasClass('itg_wall1')){
        var input_data= $(this).val();
        first_wall= first_wall * input_data; 
      }   
      if($(this).hasClass('itg_wall2')){
        var input_data= $(this).val();
        second_wall= second_wall * input_data; 
      }   
      if($(this).hasClass('itg_wall3')){
        var input_data= $(this).val();
        third_wall= third_wall * input_data; 
      }   
      if($(this).hasClass('itg_wall4')){
        var input_data= $(this).val();
        four_wall= four_wall * input_data; 
      }   
      //alert(input_data);
  });

    var total_wall = first_wall + second_wall + third_wall + four_wall;
    var single_wall= Math.ceil(total_wall/ 24);
     //alert(single_wall);
    if (single_wall % 2 === 0)  {
     // alert('even')
    }  //invalid markup I know!
   else {
     var single_wall= single_wall + 1;
   }
    var double_wall= Math.ceil(total_wall/ 48);
    // alert(double_wall);
    if (double_wall % 2 === 0)  {
      //alert(double_wall);
    }  //invalid markup I know!
   else {
     var double_wall= double_wall;
   }
    
    $('.itg_single_rolls').val(single_wall);
    $('.itg_double_rolls').val(double_wall);
  });

  //collection page custom compare btn click
$('.itg_hover_icon .itg_compare_btn').on('click', function (e) {
  $(this).parents('.card-wrapper').find('label.SPCMP_chk_lbl').trigger('click');
  $(this).toggleClass('active');
});
  $('.itg_list_view_data .itg_compare').on('click', function (e) {
  $(this).parents('.card-wrapper').find('label.SPCMP_chk_lbl').trigger('click');
  $(this).toggleClass('active');
});
  
  $('label.SPCMP_chk_lbl .SPCMP_Add:checked').each(function(){
    $(this).parents('.card-wrapper').find('.itg_hover_icon .itg_compare_btn').addClass('active');
  });
  
   

  //menu hover 
  // $('.header.itg_header nav.header__inline-menu li.itg_sidebar_style_menu').mouseover(function() {
  //   $('.header.itg_header nav.header__inline-menu li.itg_sidebar_style_menu .mega-menu').attr('open', false);
  //   $(this).find('.mega-menu').attr('open', true);
  // });
  //  $('.header.itg_header nav.header__inline-menu li.itg_sidebar_style_menu').mouseout(function(){   
  //    $('.header.itg_header nav.header__inline-menu li.itg_sidebar_style_menu .mega-menu').attr('open', false);
  //  });
  
   
  if( $(document).find('.itg_filters_main').length ){
    var collectionId = $(document).find('.itg_filters_main').data('id');
    if( collectionId !== '' ){
      //$(document).find('body').addClass('itg-loading');
      var currentTags = $(document).find('.itg_filters_main').data('current');
      var form_data = {
        collectionid : collectionId,
        current : currentTags
      };
      console.log('form_data', form_data)
      $.ajax({
          type: 'POST',
          url: 'https://mahoneswallpapershop.net/app/filter/config.php',
          data: form_data,	
          dataType: "json",			
          success: function( response ){ 
            var responseTags = response.data;
              console.log('responseTags',responseTags);
             if( responseTags != '' ){
              var $html = '';
              $html +='<div class="filter_header"><h3 class="header_text">Filter</h3><span class="itg_filter_icon itg_filter_close"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17">       <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path></svg></span></div> <div class="itg_filter">';
              $html +='<button class="accordion active"><h5>Collection</h5></button>';
                $html +='<div class="panel">';
                  $html +='<ul class="nav">';
                    $.each( responseTags, function( key, value ) {
                      if( value != '' ){
                        var valueHandle = value.toLowerCase().replace(/\//g, '-').replace(/ /g, '-').replace(/-$/, '').replace(/^-/, '').replace(/\./g, '');
                        var valueTitle = value.split("_");
                        if( value.indexOf('Collection_') != -1 ){
                          if( valueTitle[1] != '' ){
                            var valueTitleHandle = valueTitle[1].toLowerCase().replace(/\//g, '-').replace(/ /g, '-').replace(/-$/, '').replace(/^-/, '');
                            $html +='<li class="collection-sidebar__filter-item main-filter" data-check="'+value+'" data-title="'+valueTitleHandle+'" data-tag="'+valueHandle+'"><label for="'+valueHandle+'"><input class="itg-filter-tag" type="checkbox" name="Collection" id="'+valueHandle+'" value="'+valueHandle+'"><span class="itg_checkbox"></span> <span class="itg_filter_text">'+valueTitle[1]+'</span></label></li>';
                          }
                        }
                      }
                    });
                  $html +='</ul>';
                $html +='</div>';
              $html +='</div>';
              $html +='<div class="itg_filter">';
              $html +='<button class="accordion active"><h5>Color</h5></button>';
                $html +='<div class="panel">';
                  $html +='<ul class="nav">';
                    $.each( responseTags, function( key, value ) {
                      if( value != '' ){
                        var valueHandle = value.toLowerCase().replace(/\//g, '-').replace(/ /g, '-').replace(/-$/, '').replace(/^-/, '').replace(/\./g, '');
                        var valueTitle = value.split("_");
                        if( value.indexOf('Color_') != -1 ){
                          if( valueTitle[1] != '' ){
                            var valueTitleHandle = valueTitle[1].toLowerCase().replace(/\//g, '-').replace(/ /g, '-').replace(/-$/, '').replace(/^-/, '');
                            $html +='<li class="collection-sidebar__filter-item main-filter" data-check="'+value+'" data-title="'+valueTitleHandle+'" data-tag="'+valueHandle+'"><label for="'+valueHandle+'"><input class="itg-filter-tag" type="checkbox" name="Collection" id="'+valueHandle+'" value="'+valueHandle+'"><span class="itg_checkbox"></span> <span class="itg_filter_text">'+valueTitle[1]+'</span></label></li>';
                          }
                        }
                      }
                    });
                  $html +='</ul>';
                $html +='</div>';
              $html +='</div>';
              $html +='<div class="itg_filter">';
              $html +='<button class="accordion active"><h5>Theme</h5></button>';
                $html +='<div class="panel">';
                  $html +='<ul class="nav">';
                    $.each( responseTags, function( key, value ) {
                      if( value != '' ){
                        var valueHandle = value.toLowerCase().replace(/\//g, '-').replace(/ /g, '-').replace(/-$/, '').replace(/^-/, '').replace(/\./g, '');
                        var valueTitle = value.split("_");
                        if( value.indexOf('Theme_') != -1 ){
                          if( valueTitle[1] != '' ){
                            var valueTitleHandle = valueTitle[1].toLowerCase().replace(/\//g, '-').replace(/ /g, '-').replace(/-$/, '').replace(/^-/, '');
                            $html +='<li class="collection-sidebar__filter-item main-filter" data-check="'+value+'" data-title="'+valueTitleHandle+'" data-tag="'+valueHandle+'"><label for="'+valueHandle+'"><input class="itg-filter-tag" type="checkbox" name="Collection" id="'+valueHandle+'" value="'+valueHandle+'"><span class="itg_checkbox"></span> <span class="itg_filter_text">'+valueTitle[1]+'</span></label></li>';
                          }
                        }
                      }
                    });
                  $html +='</ul>';
                $html +='</div>';
              $html +='</div>';
              $html +='<div class="itg_filter">';
              $html +='<button class="accordion active"><h5>Type</h5></button>';
                $html +='<div class="panel">';
                  $html +='<ul class="nav">';
                    $.each( responseTags, function( key, value ) {
                      if( value != '' ){
                        var valueHandle = value.toLowerCase().replace(/\//g, '-').replace(/ /g, '-').replace(/-$/, '').replace(/^-/, '').replace(/\./g, '');
                        var valueTitle = value.split("_");
                        if( value.indexOf('Type_') != -1 ){
                          if( valueTitle[1] != '' ){
                            var valueTitleHandle = valueTitle[1].toLowerCase().replace(/\//g, '-').replace(/ /g, '-').replace(/-$/, '').replace(/^-/, '');
                            $html +='<li class="collection-sidebar__filter-item main-filter" data-check="'+value+'" data-title="'+valueTitleHandle+'" data-tag="'+valueHandle+'"><label for="'+valueHandle+'"><input class="itg-filter-tag" type="checkbox" name="Collection" id="'+valueHandle+'" value="'+valueHandle+'"><span class="itg_checkbox"></span> <span class="itg_filter_text">'+valueTitle[1]+'</span></label></li>';
                          }
                        }
                      }
                    });
                  $html +='</ul>';
                $html +='</div>';
              $html +='</div>';
              $html +='<div class="itg_filter">';
              $html +='<button class="accordion active"><h5>Pasted</h5></button>';
                $html +='<div class="panel">';
                  $html +='<ul class="nav">';
                    $.each( responseTags, function( key, value ) {
                      if( value != '' ){
                        var valueHandle = value.toLowerCase().replace(/\//g, '-').replace(/ /g, '-').replace(/-$/, '').replace(/^-/, '').replace(/\./g, '');
                        var valueTitle = value.split("_");
                        if( value.indexOf('Pasted_') != -1 ){
                          if( valueTitle[1] != '' ){
                            var valueTitleHandle = valueTitle[1].toLowerCase().replace(/\//g, '-').replace(/ /g, '-').replace(/-$/, '').replace(/^-/, '');
                            $html +='<li class="collection-sidebar__filter-item main-filter" data-check="'+value+'" data-title="'+valueTitleHandle+'" data-tag="'+valueHandle+'"><label for="'+valueHandle+'"><input class="itg-filter-tag" type="checkbox" name="Collection" id="'+valueHandle+'" value="'+valueHandle+'"><span class="itg_checkbox"></span> <span class="itg_filter_text">'+valueTitle[1]+'</span></label></li>';
                          }
                        }
                      }
                    });
                  $html +='</ul>';
                $html +='</div>';
              $html +='</div>';
              $html +='<div class="itg_filter">';
              $html +='<button class="accordion active"><h5>Page</h5></button>';
                $html +='<div class="panel">';
                  $html +='<ul class="nav">';
                    $.each( responseTags, function( key, value ) {
                      if( value != '' ){
                        var valueHandle = value.toLowerCase().replace(/\//g, '-').replace(/ /g, '-').replace(/-$/, '').replace(/^-/, '').replace(/\./g, '');
                        var valueTitle = value.split("_");
                        if( value.indexOf('Page_') != -1 ){
                          if( valueTitle[1] != '' ){
                            var valueTitleHandle = valueTitle[1].toLowerCase().replace(/\//g, '-').replace(/ /g, '-').replace(/-$/, '').replace(/^-/, '');
                            $html +='<li class="collection-sidebar__filter-item main-filter" data-check="'+value+'" data-title="'+valueTitleHandle+'" data-tag="'+valueHandle+'"><label for="'+valueHandle+'"><input class="itg-filter-tag" type="checkbox" name="Collection" id="'+valueHandle+'" value="'+valueHandle+'"><span class="itg_checkbox"></span> <span class="itg_filter_text">'+valueTitle[1]+'</span></label></li>';
                          }
                        }
                      }
                    });
                  $html +='</ul>';
                $html +='</div>';
              $html +='</div>';
              $(document).find('.itg_filters_main').html($html);
              var stores_li = document.querySelectorAll('.collection-sidebar__filter-item');
                [].slice.call(stores_li).sort(function(a, b) {
                    var textA = a.getAttribute('data-title').toLowerCase()
                    var textB = b.getAttribute('data-title').toLowerCase()
                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                }).forEach(function(el) {el.parentNode.appendChild(el)});
            }
            $(document).find('body').removeClass('itg-loading');
            $(document).find('.itg_filters_main').find('.itg_filter').each(function(){
              if( $(this).find('.collection-sidebar__filter-item').length ){
                $(this).removeClass('deactivate');
              }else{
                $(this).addClass('deactivate');
              }
            });
            var currentTagActive = $(document).find('.itg_filters_main').data('active');
            var currentTagActiveArray = currentTagActive.split(",");
            $(document).find('.collection-sidebar__filter-item').each(function(){
              var _value = $(this).data('check');
              var _this = $(this);
              $.each( currentTagActiveArray, function( key, value ) {
                if( _value == value ){
                  _this.find('.itg-filter-tag').prop('checked',true);
                }
              });
            });

            var activeFilter = 0;
            var activeFilterHtml = '';
                activeFilterHtml += '<label>Results for :</label>';
                activeFilterHtml += '<ul>';
            $.each( currentTagActiveArray, function( key, value ) {
              if( value.length > 0 ){
                var valueDetail = value.split("_");
                activeFilter = 1;
                activeFilterHtml += '<li><span data-tag="'+value+'">'+valueDetail[0]+' : '+valueDetail[1]+'</span></li>';
              }
            });
            activeFilterHtml += '</ul>';

            if( activeFilter === 1 ){
              $(document).find('.itg-active-filter').html(activeFilterHtml);
            }
            
          },
          error: function(data){
            console.log(data);
            // location.reload();
          }
      }); 
    }
    
    $(document).on('click','.accordion',function(){
      if( $(this).hasClass('active') ){
        $(this).closest('.itg_filter').find('.panel').slideUp();
        $(this).removeClass('active');
      }else{
        $(this).closest('.itg_filter').find('.panel').slideDown();
        $(this).addClass('active');
      }
    });
//custom filter btn on mobile 

$(".itg_filter_icon").on("click", function() {
    $('.itg_filters_main').css('right','0');
});
$(document).on('click','.itg_filter_close',function(){
     $('.itg_filters_main').css('right','-100%');
}); 
    /*
    function itgAjaxFilter(){
      var collectionUrl = $(document).find()
    }
    */
    
    $(document).on('change','.itg-filter-tag',function(){
      //itgAjaxFilter();
      var collectionUrl = $(document).find('.itg_filters_main').data('url');
      var tags = '';
      var count = 0;
      $(document).find('.itg-filter-tag').each(function(){
        if( $(this).is(':checked') ){
          if( count > 0 ){
            tags += '+'+$(this).val();
          }else{
            tags += $(this).val();
          }
          count = count+1;
        }
      });
      location.href=collectionUrl+"/"+tags;
    });

    $(document).on('click','.itg-active-filter span',function(){
      var current_tag = $(this).data('tag');
      $(document).find('.collection-sidebar__filter-item[data-check="'+current_tag+'"]').find('.itg-filter-tag').prop('checked',false).change();
    });
    
  }

   // collection page image slider
  $('.itg_collection_img_slider').slick({
    dots: false,
    autoplay: false,
    autoplaySpeed: 1000,
    arrows: false,
    fade: true,
  });
  
  $('.itg_collection_img_slider').mouseover(function() {
        $(this).slick('play')
    });
    $('.itg_collection_img_slider').mouseout(function() {
        $(this).slick('pause')
    });
  

////load more

  window.itgInitCardSliders = function (scope) {
    var $sliders = $(scope || document).find('.itg_collection_img_slider').not('.slick-initialized');
    if (!$sliders.length) { return; }

    $sliders.slick({
      dots: false,
      autoplay: false,
      autoplaySpeed: 1000,
      arrows: false,
      fade: true
    });

    $sliders.on('mouseenter.itgCard', function () { $(this).slick('play'); });
    $sliders.on('mouseleave.itgCard', function () { $(this).slick('pause'); });
  };

  /* --------------------------------------------------------------------------
     Lazy image rescue.
     A `loading="lazy"` image that sits in a faded slick slide can end up with a
     zero-sized box, so the browser skips the request and the card stays empty
     when the shopper scrolls back up. Re-request anything that is in view but
     still has no pixels.
  -------------------------------------------------------------------------- */
  window.itgWatchLazyImages = (function () {
    if (!('IntersectionObserver' in window)) { return function () {}; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) { return; }

        var img = entry.target;
        io.unobserve(img);
        if (img.complete && img.naturalWidth > 0) { return; }

        var src = img.getAttribute('src');
        img.setAttribute('loading', 'eager');
        if (src) { img.setAttribute('src', src); }
      });
    }, { rootMargin: '400px 0px', threshold: 0 });

    return function (scope) {
      var root = (scope && scope.nodeType === 1) ? scope : document;
      var imgs = root.querySelectorAll('.itg_collection_img_slider img:not([data-itg-lazy-watched])');

      Array.prototype.forEach.call(imgs, function (img) {
        img.setAttribute('data-itg-lazy-watched', 'true');
        img.setAttribute('decoding', 'async');
        io.observe(img);
      });
    };
  })();

  window.itgInitCardSliders(document);
  window.itgWatchLazyImages(document);

  /* --------------------------------------------------------------------------
     Load more - fetches the next paginated page and appends it to the grid.
  -------------------------------------------------------------------------- */
  $(document).on('click', '#more a', function (e) {
    e.preventDefault();

    var $more = $('#more');
    var scrollURL = $(this).attr('href');
    if (!scrollURL || $more.hasClass('itg-fetching')) { return; }

    $more.addClass('itg-fetching itg-loading');

    $.ajax({
      type: 'GET',
      url: scrollURL,
      dataType: 'html',
      success: function (data) {
        var $page = $('<div></div>').append($.parseHTML(data));
        var $grid = $('.itg_collection_grid').first();
        var $newItems = $page.find('.itg_collection_grid').children();

        if ($grid.length && $newItems.length) {
          $grid.append($newItems);
          window.itgInitCardSliders($newItems);
          window.itgWatchLazyImages($grid[0]);
        }

        var $nextMore = $page.find('#more');
        if ($nextMore.length) {
          $more.html($nextMore.html());
        } else {
          $more.remove();
        }
      },
      complete: function () {
        $('#more').removeClass('itg-fetching itg-loading');
        document.dispatchEvent(new CustomEvent('itg:loadmore:done'));
      }
    });
  });

  //collection page order sample - delegated, so appended / filtered cards work
  //too and old cards never end up with a duplicated handler.
  $(document).on('click', '.order_sample', function () {
    var _this = $(this);
    var handleP = _this.attr('data-ProductHandle');
    if (!handleP) { return; }

    $.ajax({
      url: handleP,
      type: 'GET',
      success: function (data) {
        var idsv = $(data).find('.order_sample').attr('data-variantid');
        _this.attr('data-variantid', idsv);
        var variant_id = _this.attr('data-variantid');
        if (variant_id != '') {
          var old_variant_id = _this.closest('.itg_collection_form').find('.itg_option').val();
          _this.closest('.itg_collection_form').find('.itg_option').val(variant_id);
          _this.closest('.itg_collection_form').find('.quick-add__submit').click();
          _this.closest('.itg_collection_form').find('.itg_option').val(old_variant_id);
        }
      }
    });
  });
});

// setInterval(function (e) {
//      var thisvalue = $('div#CartDrawer-CartItems ').find('.cart-item td.cart-item__quantity .cartDrawerSelect').attr('dataQuantity');
//       $('div#CartDrawer-CartItems ').find('.cart-item td.cart-item__quantity .cartDrawerSelect').each(function() { 
//           var thisOption = $(this).find('option').val();
//         if(thisvalue == thisOption){
//            $(this).attr("selected","selected");
//         }
//       });
// },1000);

var discountCode = document.querySelector('.itg_discount_code');
if(discountCode){
  document.querySelector('.itg_discount_code').addEventListener("click", function() {
    const el = document.querySelector('.main_code');
    if (el) {
      const text = el.innerText.trim();
      navigator.clipboard.writeText(text)
        .then(() => {
          console.log("Text copied to clipboard!");
        })
        .catch(err => {
          console.log("Failed to copy text: " + err);
        });
    } else {
      console.log("Element not found.");
    }
  })
}

/* ============================================================================
   Infinite scroll (collection page)
============================================================================ */

(function () {
  var scrollObserver = null;
  var gridObserver = null;
  var containerObservers = [];
  var rebindTimer = null;
  var isLoading = false;

  function refreshCards(scope) {
    if (typeof window.itgInitCardSliders === 'function') {
      window.itgInitCardSliders(scope || document);
    }
    if (typeof window.itgWatchLazyImages === 'function') {
      window.itgWatchLazyImages(scope || document);
    }
  }

  function stop() {
    if (scrollObserver) { scrollObserver.disconnect(); scrollObserver = null; }
    if (gridObserver) { gridObserver.disconnect(); gridObserver = null; }
    isLoading = false;
  }

  function bind() {
    stop();
    watchContainers();

    var grid = document.querySelector('.itg_collection_grid');
    if (!grid) { return; }

    // a filtered / sorted render brings in fresh cards that own no slider yet
    refreshCards(grid);

    var moreEl = document.getElementById('more');
    if (!moreEl || !moreEl.querySelector('a')) { return; }

    gridObserver = new MutationObserver(function (mutations) {
      var appended = false;
      var staggerIndex = 0;

      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType !== 1 || !node.classList.contains('grid__item')) { return; }
          appended = true;
          node.classList.add('itg-infinite-item');
          node.style.animationDelay = (staggerIndex * 70) + 'ms';
          staggerIndex++;
        });
      });

      if (appended) { refreshCards(grid); }
    });
    gridObserver.observe(grid, { childList: true });

    scrollObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || isLoading) { return; }

        var current = document.getElementById('more');
        var link = current && current.querySelector('a');
        if (!link) { stop(); return; }

        isLoading = true;
        current.classList.add('itg-loading');
        link.click();
      });
    }, { rootMargin: '600px 0px', threshold: 0 });

    scrollObserver.observe(moreEl);
  }

  function scheduleRebind() {
    clearTimeout(rebindTimer);
    rebindTimer = setTimeout(bind, 60);
  }

  /* Watch the two wrappers that get their innerHTML swapped when a filter or a
     sort is applied. childList only (no subtree) so appending cards inside the
     grid never re-triggers this - we only care about the container itself being
     replaced. Re-registered on every bind because a swap can destroy the very
     node we were observing. */
  function watchContainers() {
    if (!('MutationObserver' in window)) { return; }

    containerObservers.forEach(function (observer) { observer.disconnect(); });
    containerObservers = [];

    ['.itg_filter_maindiv', '#ProductGridContainer'].forEach(function (selector) {
      var host = document.querySelector(selector);
      if (!host) { return; }
      var observer = new MutationObserver(scheduleRebind);
      observer.observe(host, { childList: true });
      containerObservers.push(observer);
    });
  }

  document.addEventListener('itg:loadmore:done', function () {
    isLoading = false;

    var moreEl = document.getElementById('more');
    if (!moreEl || !moreEl.querySelector('a')) { stop(); return; }

    moreEl.classList.remove('itg-loading');
    if (scrollObserver) {
      scrollObserver.unobserve(moreEl);
      scrollObserver.observe(moreEl);
    } else {
      scheduleRebind();
    }
  });

  function boot() {
    bind();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();